import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Features from "../components/Features/FeatureIncubation";

const ServiceIncubation = () => (
    <>
        <Seo
            title="서비스 인큐베이션"
            description="창의적인 ICT융합사업 아이디어를 인큐베이팅하여 사업화까지 함께합니다."
            path="/service-incubation"
        />
        <Hero />  
        <Features />
        <Footer />
    </>
);

export default ServiceIncubation;
